module.exports = __webpack_public_path__ + "static/media/stop-19.5f6f0cab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-19.svg
// module id = 1364
// module chunks = 0